 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import A425138240_00_COVER from '@/components/0425138240_00_cover'
 import A425138240_06_CPY from '@/components/0425138240_06_cpy'
 import LOVE_1 from '@/components/love_1'
 import A425138240_08_TOC from '@/components/0425138240_08_toc'
 import A425138240_09_INT from '@/components/0425138240_09_int'
 import A425138240_10_PART1 from '@/components/0425138240_10_part1'
 import A425138240_11_CH1 from '@/components/0425138240_11_ch1'
 import A425138240_12_CH2 from '@/components/0425138240_12_ch2'
 import A425138240_13_CH3 from '@/components/0425138240_13_ch3'
 import A425138240_14_CH4 from '@/components/0425138240_14_ch4'
 import A425138240_15_CH5 from '@/components/0425138240_15_ch5'
 import A425138240_16_SID from '@/components/0425138240_16_sid'
 import A425138240_17_PART2 from '@/components/0425138240_17_part2'
 import A425138240_18_CH6 from '@/components/0425138240_18_ch6'
 import A425138240_19_CH7 from '@/components/0425138240_19_ch7'
 import A425138240_20_CH8 from '@/components/0425138240_20_ch8'
 import A425138240_21_CH9 from '@/components/0425138240_21_ch9'
 import A425138240_22_SID from '@/components/0425138240_22_sid'
 import A425138240_23_PART3 from '@/components/0425138240_23_part3'
 import A425138240_24_CH10 from '@/components/0425138240_24_ch10'
 import A425138240_25_CH11 from '@/components/0425138240_25_ch11'
 import A425138240_26_CH12 from '@/components/0425138240_26_ch12'
 import A425138240_27_CH13 from '@/components/0425138240_27_ch13'
 import A425138240_28_CH14 from '@/components/0425138240_28_ch14'
 import A425138240_29_SID from '@/components/0425138240_29_sid'
 import A425138240_30_PART4 from '@/components/0425138240_30_part4'
 import A425138240_31_CH15 from '@/components/0425138240_31_ch15'
 import A425138240_32_CH16 from '@/components/0425138240_32_ch16'
 import A425138240_33_CH17 from '@/components/0425138240_33_ch17'
 import A425138240_34_CH18 from '@/components/0425138240_34_ch18'
 import A425138240_35_CH19 from '@/components/0425138240_35_ch19'
 import A425138240_36_CH20 from '@/components/0425138240_36_ch20'
 import LOVE_2 from '@/components/love_2'
 import A425138240_37_ACK from '@/components/0425138240_37_ack'
 import A425138240_38_ABT from '@/components/0425138240_38_abt'
 import CHAP229167 from '@/components/chap229167'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/0425138240_00_cover",
 			"name" : "0425138240_00_cover",
 			"component" : A425138240_00_COVER
 		},
 		{
 			"path" : "/0425138240_06_cpy",
 			"name" : "0425138240_06_cpy",
 			"component" : A425138240_06_CPY
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/0425138240_08_toc",
 			"name" : "0425138240_08_toc",
 			"component" : A425138240_08_TOC
 		},
 		{
 			"path" : "/0425138240_09_int",
 			"name" : "0425138240_09_int",
 			"component" : A425138240_09_INT
 		},
 		{
 			"path" : "/0425138240_10_part1",
 			"name" : "0425138240_10_part1",
 			"component" : A425138240_10_PART1
 		},
 		{
 			"path" : "/0425138240_11_ch1",
 			"name" : "0425138240_11_ch1",
 			"component" : A425138240_11_CH1
 		},
 		{
 			"path" : "/0425138240_12_ch2",
 			"name" : "0425138240_12_ch2",
 			"component" : A425138240_12_CH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js